// extracted by mini-css-extract-plugin
module.exports = {"layout":"App_layout__11VGl"};